<div class="hom hcm">
  <!-- La vara: solo se compara lo medido con la misma -->
  <section class="hom-card hcm-vara">
    <div class="hcm-vara__fila">
      <label class="hcm-vara__etiqueta" for="hcm-vara">Vara (rúbrica · suite · prompts)</label>
      @if (varas.length) {
        <select id="hcm-vara" class="hcm-vara__select" [disabled]="cargando" (change)="alElegirVara($event)">
          @for (v of varas; track claveVara(v)) {
            <option [value]="claveVara(v)" [selected]="v === vara">{{ textoVara(v) }}</option>
          }
        </select>
      }
    </div>
    <p class="hom-nota hcm-vara__nota">
      Solo se compara lo que se midió con la misma vara. Un modelo medido con otra aparece en la suya: para compararlos hay que recalificar a los dos con la misma versión.
    </p>
  </section>

  @if (cargandoVaras || cargando) {
    <section class="table-page__card">
      <div class="table-page__empty">
        <i class="material-icons" aria-hidden="true">hourglass_top</i>
        <strong>{{ cargandoVaras ? "Cargando las varas…" : "Armando la comparativa…" }}</strong>
      </div>
    </section>
  } @else if (error) {
    <section class="table-page__card">
      <div class="table-page__empty" role="alert">
        <i class="material-icons" aria-hidden="true">error_outline</i>
        <strong>{{ error }}</strong>
        <button type="button" class="app-form-btn app-form-btn--secondary app-form-btn--compact" (click)="reintentar()">Reintentar</button>
      </div>
    </section>
  } @else if (!varas.length) {
    <section class="table-page__card">
      <div class="table-page__empty">
        <i class="material-icons" aria-hidden="true">leaderboard</i>
        <strong>Todavía no hay evaluaciones cargadas</strong>
        <span>Cuando haya al menos dos modelos evaluados con la misma vara, aquí se ve en qué es mejor cada uno.</span>
      </div>
    </section>
  } @else if (comparativa) {
    @let c = comparativa;

    @if (c.fuera?.length) {
      <p class="hom-aviso" role="status">
        No entran a la comparación:
        @for (m of c.fuera; track m.idEval; let ultimo = $last) {
          <strong>{{ etiqueta(m) }}</strong>@if (!ultimo) {, }
        }.
        Se {{ c.fuera.length === 1 ? "comparó" : "compararon" }} contra una calificación del baseline que ya se reemplazó: hay que recalificar con <code class="hom-mono">--contra</code> y volver a cargar.
      </p>
    }

    @if (c.modelos.length < 2) {
      <section class="table-page__card">
        <div class="table-page__empty">
          <i class="material-icons" aria-hidden="true">compare_arrows</i>
          <strong>Hace falta al menos otro modelo, u otra configuración, evaluado con esta vara para comparar</strong>
          @if (c.modelos.length === 1) {
            <span>Por ahora solo está {{ etiqueta(c.modelos[0]) }}; abajo, su resultado.</span>
          }
        </div>
      </section>
      @if (unico) {
        <!-- Con una sola configuración no hay franja: la ficha va en su resumen -->
        <app-resultado-resumido [resumen]="unico" [ficha]="fichaUnica"></app-resultado-resumido>
      }
    } @else {
      <!-- 1 · Tabla resumen -->
      <section class="hom-card">
        <h3 class="hom-h3">Resumen · {{ c.modelos.length }} configuraciones</h3>
        <div class="hom-tabla-caja">
          <table class="table-page__table hom-interna hcm-tabla hcm-tabla--resumen">
            <thead>
              <tr>
                <th scope="col">Modelo</th>
                <th scope="col">Dictamen</th>
                <th scope="col">Veredicto del harness</th>
                <th scope="col" class="hom-num">Capacidad</th>
                <th scope="col" class="hom-num">Costo por tarea resuelta</th>
                <th scope="col" class="hom-num">Latencia p95</th>
                <th scope="col" class="hom-num">Consistencia</th>
                <th scope="col" class="hom-num">Tareas resueltas</th>
                <th scope="col" class="table-page__actions-head"><span class="hcm-oculto">Acciones</span></th>
              </tr>
            </thead>
            <tbody>
              @for (m of c.modelos; track m.idEval) {
                <tr>
                  <td>
                    <div class="table-page__cell-stack">
                      <span class="table-page__name"><span class="hcm-punto" [style.background]="color(m)" aria-hidden="true"></span>{{ m.nombre }}</span>
                      @if (m.nombreConfiguracion) {
                        <span class="table-page__subtext">{{ m.nombreConfiguracion }}</span>
                      }
                      <span class="table-page__subtext">
                        <code class="hom-mono">{{ m.identificador }}</code>
                        @if (m.vigente) { · <strong class="hcm-vigente">Vigente</strong> }
                      </span>
                    </div>
                  </td>
                  <td>
                    @if (m.dictamen) {
                      <span class="table-page__status-badge" [class]="'table-page__status-badge ' + dictamenClase(m.dictamen)">{{ dictamenTexto(m.dictamen) }}</span>
                    } @else {
                      <span class="table-page__subtext">Sin dictamen</span>
                    }
                  </td>
                  <td><span class="table-page__subtext">{{ veredictoTexto(m.veredicto) }}</span></td>
                  <td class="hom-num">
                    <strong>@if (num(m.capacidad) !== null) { {{ m.capacidad | number: "1.1-1" }} } @else { — }</strong>
                    @if (lider("CAPACIDAD", m); as v) { <span class="hcm-lider" [attr.title]="'Mejor por ' + margen(v)">▲ {{ margen(v) }}</span> }
                  </td>
                  <td class="hom-num">
                    @if (num(m.costoPorTareaUsd) !== null) { $ {{ m.costoPorTareaUsd | number: "1.2-2" }} } @else { — }
                    @if (lider("COSTO", m); as v) { <span class="hcm-lider">▲ {{ margen(v) }}</span> }
                  </td>
                  <td class="hom-num">
                    @if (num(m.latenciaP95S) !== null) { {{ m.latenciaP95S | number: "1.0-1" }} s } @else { — }
                    @if (lider("LATENCIA", m); as v) { <span class="hcm-lider">▲ {{ margen(v) }}</span> }
                  </td>
                  <td class="hom-num">@if (num(m.consistenciaScore) !== null) { {{ m.consistenciaScore | number: "1.1-1" }} } @else { — }</td>
                  <td class="hom-num">{{ m.tareasResueltas ?? "—" }} / {{ m.tareasTotales ?? "—" }}</td>
                  <td class="table-page__actions">
                    <button type="button" class="table-page__action-btn" [attr.aria-label]="'Ver resultado de ' + etiqueta(m)" title="Ver resultado" (click)="abrir.emit(m.idEval)">
                      <i class="material-icons" aria-hidden="true">insights</i>
                    </button>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </section>

      <!-- 2 · En qué es mejor cada uno -->
      <section class="hom-card">
        <h3 class="hom-h3">En qué es mejor cada uno</h3>
        <p class="hom-nota">Es «mejor» con 1.0 punto o más en capacidad, rubros y tareas, o con 10 % o más menos en costo y latencia. Una diferencia menor es ruido entre corridas: se lee Equivalentes.</p>
        <div class="hcm-tarjetas">
          @for (t of tarjetas; track t.modelo.idEval) {
            <article class="hcm-tarjeta" [style.border-top-color]="color(t.modelo)">
              <h4 class="hcm-tarjeta__titulo">{{ t.modelo.nombre }}
                @if (t.modelo.nombreConfiguracion) { <span class="hcm-config">{{ t.modelo.nombreConfiguracion }}</span> }
              </h4>
              @if (t.ventajas.length) {
                <ul class="hcm-tarjeta__lista">
                  @for (v of t.ventajas; track v.tipo + v.clave) {
                    <li>
                      <span class="hcm-tarjeta__que">@if (tipoTexto(v.tipo)) { <span class="hcm-tarjeta__tipo">{{ tipoTexto(v.tipo) }}</span> }{{ v.nombre }}</span>
                      <strong class="hcm-tarjeta__margen">{{ margen(v) }}</strong>
                    </li>
                  }
                </ul>
              } @else {
                <p class="hcm-tarjeta__vacia">Ninguna ventaja que pase el umbral.</p>
              }
            </article>
          }
        </div>
        @if (equivalentes.length) {
          <div class="hcm-equivalentes">
            <strong>Equivalentes</strong>
            <span>{{ equivalentes.length }} {{ equivalentes.length === 1 ? "medida" : "medidas" }} sin una diferencia que pase el umbral:</span>
            <ul>
              @for (v of equivalentes; track v.tipo + v.clave) {
                <li>@if (tipoTexto(v.tipo)) { <span class="hcm-tarjeta__tipo">{{ tipoTexto(v.tipo) }}</span> }{{ v.nombre }}</li>
              }
            </ul>
          </div>
        }
      </section>

      <!-- 3 · Radar por rubro, con la tabla de números -->
      <section class="hom-card">
        <h3 class="hom-h3">Capacidad por área</h3>
        <div class="hcm-elegir" role="group" aria-label="Configuraciones en el radar">
          <span class="hom-nota hcm-elegir__nota">En el radar (hasta {{ MAX_RADAR }}):</span>
          @for (m of c.modelos; track m.idEval) {
            <button type="button" class="hcm-chip" [class.is-activo]="enRadar.has(m.idEval)" [attr.aria-pressed]="enRadar.has(m.idEval)"
              [disabled]="!enRadar.has(m.idEval) && enRadar.size >= MAX_RADAR" (click)="alternarRadar(m)">
              <span class="hcm-punto" [style.background]="color(m)" aria-hidden="true"></span>{{ etiqueta(m) }}
            </button>
          }
        </div>
        <div class="hom-area">
          <div class="hom-area__radar">
            <app-radar-rubros [etiquetas]="etiquetasRadar" [series]="seriesRadar" descripcion="Capacidad por rubro de las configuraciones elegidas"></app-radar-rubros>
          </div>
          <div class="hom-tabla-caja hom-area__tabla">
            <ng-container *ngTemplateOutlet="tablaFilas; context: { $implicit: c.rubros, titulo: 'Rubro' }"></ng-container>
          </div>
        </div>
      </section>

      <!-- 4 · Por tarea: solo el nombre -->
      <section class="hom-card">
        <h3 class="hom-h3">Capacidad por tarea</h3>
        <div class="hom-tabla-caja">
          <ng-container *ngTemplateOutlet="tablaFilas; context: { $implicit: c.tareas, titulo: 'Tarea' }"></ng-container>
        </div>
      </section>

      <!-- 5 · Evolución: en el orden en que se evaluaron -->
      <section class="hom-card">
        <h3 class="hom-h3">Evolución</h3>
        <p class="hom-nota">Capacidad y costo por tarea resuelta, en el orden en que se evaluaron.</p>
        <ol class="hcm-evolucion">
          @for (m of c.modelos; track m.idEval) {
            <li class="hcm-evolucion__paso">
              <div class="hcm-evolucion__cabeza">
                <span class="hcm-evolucion__nombre"><span class="hcm-punto" [style.background]="color(m)" aria-hidden="true"></span>{{ m.nombre }}
                  @if (m.nombreConfiguracion) { <span class="hcm-config">{{ m.nombreConfiguracion }}</span> }
                </span>
                <span class="table-page__subtext">{{ m.aplicadaDesde || m.fechaCarga || "—" }}</span>
              </div>
              <div class="hcm-evolucion__barra" aria-hidden="true">
                <span [style.width.%]="barra(m)" [style.background]="color(m)"></span>
              </div>
              <div class="hcm-evolucion__datos">
                <span>Capacidad <strong>@if (num(m.capacidad) !== null) { {{ m.capacidad | number: "1.1-1" }} } @else { — }</strong></span>
                <span>Costo por tarea <strong>@if (num(m.costoPorTareaUsd) !== null) { $ {{ m.costoPorTareaUsd | number: "1.2-2" }} } @else { — }</strong></span>
              </div>
            </li>
          }
        </ol>
      </section>

      <!-- 6 · Según el catálogo: la ficha vigente de cada modelo. No ordena, no califica y no entra en «En qué es mejor cada uno» -->
      @if (franja.size) {
        <section class="hom-card">
          <h3 class="hom-h3">Según el catálogo @if (verificadoFranja) { · verificado {{ verificadoFranja }} }</h3>
          <p class="hom-nota">Lo que publica el fabricante y opina el Catálogo de Modelos de IA, de la ficha vigente de cada modelo. Informa; no califica: no cambia nada de lo de arriba. La ficha es del modelo: dos configuraciones del mismo modelo repiten sus números.</p>
          <div class="hom-tabla-caja">
            <table class="table-page__table hom-interna hcm-tabla" [style.min-width.px]="anchoFranja">
              <thead>
                <tr>
                  <th scope="col">Dato</th>
                  @for (m of c.modelos; track m.idEval) {
                    <th scope="col" class="hom-num"><span class="hcm-punto" [style.background]="color(m)" aria-hidden="true"></span>{{ m.nombre }}
                      @if (m.nombreConfiguracion) { <span class="hcm-config">{{ m.nombreConfiguracion }}</span> }
                    </th>
                  }
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Precio de entrada <span class="hcm-config">por millón de tokens</span></td>
                  @for (m of c.modelos; track m.idEval) {
                    @let f = franja.get(m.idModelo);
                    <td class="hom-num">@if (f && num(f.precioEntrada) !== null) { {{ f.moneda || "" }} {{ f.precioEntrada | number: "1.2-6" }} } @else { — }</td>
                  }
                </tr>
                <tr>
                  <td>Precio de salida <span class="hcm-config">por millón de tokens</span></td>
                  @for (m of c.modelos; track m.idEval) {
                    @let f = franja.get(m.idModelo);
                    <td class="hom-num">@if (f && num(f.precioSalida) !== null) { {{ f.moneda || "" }} {{ f.precioSalida | number: "1.2-6" }} } @else { — }</td>
                  }
                </tr>
                <tr>
                  <td>Contexto <span class="hcm-config">tokens</span></td>
                  @for (m of c.modelos; track m.idEval) {
                    @let f = franja.get(m.idModelo);
                    <td class="hom-num">@if (f && num(f.contextoTokens) !== null) { {{ f.contextoTokens | number: "1.0-0" }} } @else { — }</td>
                  }
                </tr>
                <tr>
                  <td>Salida máxima <span class="hcm-config">tokens</span></td>
                  @for (m of c.modelos; track m.idEval) {
                    @let f = franja.get(m.idModelo);
                    <td class="hom-num">@if (f && num(f.salidaMaxTokens) !== null) { {{ f.salidaMaxTokens | number: "1.0-0" }} } @else if (f?.salidaMaxTexto) { <span class="hcm-config">{{ f.salidaMaxTexto }}</span> } @else { — }</td>
                  }
                </tr>
                <tr>
                  <td>Lanzamiento</td>
                  @for (m of c.modelos; track m.idEval) {
                    @let f = franja.get(m.idModelo);
                    <td class="hom-num">@if (f?.fechaLanzamiento) { {{ fechaDmy(f?.fechaLanzamiento) }} } @else { — }</td>
                  }
                </tr>
                <tr>
                  <td>Índice del catálogo <span class="hcm-config">con su configuración</span></td>
                  @for (m of c.modelos; track m.idEval) {
                    @let f = franja.get(m.idModelo);
                    <td class="hom-num">
                      @if (f && num(f.indiceInteligencia) !== null) {
                        {{ f.indiceInteligencia | number: "1.0-2" }}
                        <span class="hcm-config">{{ f.indiceConfiguracion || "configuración no indicada" }}</span>
                      } @else { — }
                    </td>
                  }
                </tr>
                <tr>
                  <td>Top del catálogo</td>
                  @for (m of c.modelos; track m.idEval) {
                    @let f = franja.get(m.idModelo);
                    <td class="hom-num">@if (f && num(f.topRank) !== null) { #{{ f.topRank }} } @else { — }</td>
                  }
                </tr>
                <tr>
                  <td>Verificado</td>
                  @for (m of c.modelos; track m.idEval) {
                    @let f = franja.get(m.idModelo);
                    <td class="hom-num">
                      @if (f) {
                        {{ fechaDmy(f.verificado) }}
                        @if ((num(f.diasVerificada) ?? 0) > 90) { <span class="hcm-config">hace {{ f.diasVerificada }} días</span> }
                      } @else {
                        <span class="table-page__subtext">Sin ficha</span>
                      }
                    </td>
                  }
                </tr>
              </tbody>
            </table>
          </div>
        </section>
      }
    }
  }
</div>

<!-- Un renglón por rubro o por tarea: el valor de cada configuración y quién gana -->
<ng-template #tablaFilas let-filas let-titulo="titulo">
  <table class="table-page__table hom-interna hcm-tabla" [style.min-width.px]="anchoFilas">
    <thead>
      <tr>
        <th scope="col">{{ titulo }}</th>
        @for (m of comparativa?.modelos || []; track m.idEval) {
          <th scope="col" class="hom-num"><span class="hcm-punto" [style.background]="color(m)" aria-hidden="true"></span>{{ m.nombre }}
            @if (m.nombreConfiguracion) { <span class="hcm-config">{{ m.nombreConfiguracion }}</span> }
          </th>
        }
        <th scope="col">Quién gana</th>
      </tr>
    </thead>
    <tbody>
      @for (f of filas; track f.clave) {
        <tr>
          <td>{{ f.nombre }}</td>
          @for (m of comparativa?.modelos || []; track m.idEval) {
            <td class="hom-num" [class.hcm-celda-lider]="f.idEvalLider === m.idEval">
              @if (valor(f, m) !== null) { {{ valor(f, m) | number: "1.1-1" }} } @else { <span class="table-page__subtext">no aplica</span> }
            </td>
          }
          <td>
            @if (f.idEvalLider != null) {
              <span class="hcm-gana">{{ nombreDe(f.idEvalLider) }} <strong class="hcm-gana__margen">{{ margen(f, "pts") }}</strong></span>
            } @else if (f.equivalentes) {
              <span class="table-page__subtext">Equivalentes</span>
            } @else {
              <span class="table-page__subtext">Sin contra quién</span>
            }
          </td>
        </tr>
      }
    </tbody>
  </table>
</ng-template>
